module.exports = __webpack_public_path__ + "img/31423169000340.61df87cf.png";